import * as ErrorHandler from 'common/ErrorHandler';
import { Api, SecureApi } from 'common/http';
import QueryString from 'common/QueryString';

export async function getRecommendations(placeId, type, options = {}) {
  try {
    const {
      isAuthenticated,
      tokenValue,
      forceFallback,
    } = options;

    const qs = QueryString.stringify(
      {
        ab: type || null,
        force_fallback: forceFallback || null
      },
      { skipNulls: true }
    );

    const url = `/recommend/${placeId}${qs ? `?${qs}` : ''}`;

    const headers = tokenValue
      ? { 'X-Freshful-CartToken': tokenValue }
      : {};

    if (isAuthenticated) {
      const { data } = await SecureApi.get(url, { headers });
      return data;
    }

    const { data } = await Api.get(url, { headers });

    return data;

  } catch (err) {
    ErrorHandler.throwError(err, 'Error while getting recommendations - ', { placeId });
  }
}
